// import Dashboard from "views/examples/Dashboard";
// import Notifications from "views/examples/Notifications";
// import Icons from "views/examples/Icons";
// import Typography from "views/examples/Typography";
// import TableList from "views/examples/Tables";
// import Maps from "views/examples/Map";
// import UserPage from "views/examples/User";
// import UpgradeToPro from "views/examples/Upgrade";
import PredictionBoard from "views/prediction/PredictionBoard";
import CAPS from "views/prediction/CAPS";
import Zinc_Finger from "views/prediction/ZincFinger";
import CholesterolBindingMotifs from "views/prediction/CholesterolBindingMotifs";
import ENTHDomain from "views/prediction/ENTHDomain";
import PhosphoinositideBindingMotifs from "views/prediction/Phosphoinositide";
import Gquadruplex from "views/prediction/Gquadruplex";

var routes = [
  {
    path: "/scan_motif",
    name: "User Defined Motifs",
    icon: "fas fa-binoculars",
    component: PredictionBoard,
    labels: new Set(["sequence", "prediction", "protein", "nucleotide"]) // determine which dashboard include this page
  },
  {
    path: "/caps",
    name: "Calcium Binding Motifs",
    icon: "fas fa-binoculars",
    component: CAPS,
    labels: new Set(["sequence", "prediction", "protein"])
  },
  {
    path: "/cholesterol",
    name: "Cholesterol Motifs",
    icon: "fas fa-binoculars",
    component: CholesterolBindingMotifs,
    labels: new Set(["sequence", "prediction", "protein"])
  },
  {
    path: "/enth",
    name: "ENTH Domains",
    icon: "fas fa-binoculars",
    component: ENTHDomain,
    labels: new Set(["sequence", "prediction", "protein"])
  },
  {
    path: "/Gquadruplex",
    name: "G quadruplex",
    icon: "fas fa-binoculars",
    component: Gquadruplex,
    labels: new Set(["sequence", "prediction", "nucleotide"])
  },
  {
    path: "/phosphoinositide",
    name: "Phosphoinositide ...",
    icon: "fas fa-binoculars",
    component: PhosphoinositideBindingMotifs,
    labels: new Set(["sequence", "prediction", "protein"])
  },
  {
    path: "/zinc_finger",
    name: "Zinc Fingers",
    icon: "fas fa-binoculars",
    component: Zinc_Finger,
    labels: new Set(["sequence", "prediction", "protein"])
  }
];
export default routes;

/*
var routes = [
  {
    path: "/scan_motif",
    name: "scan Motifs",
    icon: "fas fa-binoculars",
    component: PredictionBoard,
    layout: "/sequence",
  },
  {
    path: "/main",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/sequence",
  },
  {
    path: "/icons",
    name: "Icons",
    icon: "nc-icon nc-diamond",
    component: Icons,
    layout: "/sequence",
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "nc-icon nc-pin-3",
    component: Maps,
    layout: "/sequence",
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "nc-icon nc-bell-55",
    component: Notifications,
    layout: "/sequence",
  },
  {
    path: "/user-page",
    name: "User Profile",
    icon: "nc-icon nc-single-02",
    component: UserPage,
    layout: "/sequence",
  },
  {
    path: "/tables",
    name: "Table List",
    icon: "nc-icon nc-tile-56",
    component: TableList,
    layout: "/sequence",
  },
  {
    path: "/typography",
    name: "Typography",
    icon: "nc-icon nc-caps-small",
    component: Typography,
    layout: "/sequence",
  },
  {
    pro: true,
    path: "/upgrade",
    name: "Upgrade to PRO",
    icon: "nc-icon nc-spaceship",
    component: UpgradeToPro,
    layout: "/sequence",
  }
];
*/